import React from 'react';
import { useSelector } from 'react-redux';
import { Box } from '@ublend-npm/aulaui-core';
import { getCanSwitchHomeViewRole } from '@app/selectors/home';
import EducatorStudentToggle from '../../EducatorStudentToggle';

type SpaceWidgetToolbarProps = {
  showRoleToggle?: boolean;
};

const SpaceWidgetToolbar = ({
  showRoleToggle = true,
}: SpaceWidgetToolbarProps) => {
  const canSwitchRole = useSelector(getCanSwitchHomeViewRole);
  const showRoleControls = showRoleToggle && canSwitchRole;

  if (!showRoleControls) {
    return null;
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={2}
      width="100%"
    >
      <Box display="flex" alignItems="center" gap={1} minWidth={0}>
        <EducatorStudentToggle />
      </Box>
    </Box>
  );
};

export default SpaceWidgetToolbar;
